/* eslint-disable no-param-reassign */

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import rtkRequestStatusCodes from "../../lib/const/rtkRequestStatusCodes";
import Message from "../../components/Message/Message";
import { getAssignRolesRoute, getBlockRolesRoute, getRolesRoute } from "../../lib/routes/security";

const initialState = {
  roles: [],
  rolesLoading: rtkRequestStatusCodes.idle,
  rolesAdding: rtkRequestStatusCodes.idle,
  rolesCreating: rtkRequestStatusCodes.idle,
};

const fetchRoles = createAsyncThunk("roles/fetchAll", async () => {
  const response = axios.get(getRolesRoute());
  const { data } = await response;
  return data;
});

const assignRolesToUser = createAsyncThunk("roles/assignRoles", async ({ userId, rolesArr }) => {
  const response = axios.post(getAssignRolesRoute(userId, rolesArr));
  const { data } = await response;
  return data;
});

const blockRolesToUser = createAsyncThunk("roles/blockRoles", async ({ userId, rolesArr }) => {
  const response = axios.post(getBlockRolesRoute(userId, rolesArr));
  const { data } = await response;
  return data;
});

const createRole = createAsyncThunk("roles/createRole", async ({ bodyObj }) => {
  const response = axios.post(getRolesRoute(), bodyObj);
  const { data } = await response;
  return data;
});

export const rolesSlice = createSlice({
  name: "roles",
  initialState,
  extraReducers: {
    [fetchRoles.fulfilled]: (state, action) => {
      state.roles = action.payload.content;
      state.rolesLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchRoles.pending]: (state) => {
      state.rolesLoading = rtkRequestStatusCodes.pending;
    },
    [fetchRoles.rejected]: (state, action) => {
      state.rolesLoading = rtkRequestStatusCodes.rejected;
      Message(action.error.message);
    },
    [assignRolesToUser.fulfilled]: (state) => {
      state.rolesAdding = rtkRequestStatusCodes.fulfilled;
    },
    [assignRolesToUser.pending]: (state) => {
      state.rolesAdding = rtkRequestStatusCodes.pending;
    },
    [assignRolesToUser.rejected]: (state, action) => {
      state.rolesAdding = rtkRequestStatusCodes.rejected;
      Message(action.error.message);
    },
    [blockRolesToUser.fulfilled]: (state) => {
      state.rolesBlocking = rtkRequestStatusCodes.fulfilled;
    },
    [blockRolesToUser.pending]: (state) => {
      state.rolesBlocking = rtkRequestStatusCodes.pending;
    },
    [blockRolesToUser.rejected]: (state) => {
      state.rolesBlocking = rtkRequestStatusCodes.rejected;
    },
    [createRole.fulfilled]: (state) => {
      state.rolesCreating = rtkRequestStatusCodes.fulfilled;
    },
    [createRole.pending]: (state) => {
      state.rolesCreating = rtkRequestStatusCodes.pending;
    },
    [createRole.rejected]: (state, action) => {
      state.rolesCreating = rtkRequestStatusCodes.rejected;
      Message(action.error.message);
    },
  },
});

const { reducer } = rolesSlice;

export { fetchRoles, assignRolesToUser, createRole, blockRolesToUser, reducer };
